import { createClient } from '@supabase/supabase-js'

// Hardcoded Supabase keys for Cloudflare deployment
const supabaseUrl = 'https://jlwhzcghzstmaltfpesx.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Impsd2h6Y2doenN0bWFsdGZwZXN4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc4NzE3ODMsImV4cCI6MjA5MzQ0Nzc4M30.LR0CAcJURoAue_J0M8tIaREt-WTV10MqvxcUhxV-Puw'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)